import { render, staticRenderFns } from "./goods-group-label.vue?vue&type=template&id=cf94f02a&scoped=true"
import script from "./goods-group-label.vue?vue&type=script&lang=js"
export * from "./goods-group-label.vue?vue&type=script&lang=js"
import style0 from "./goods-group-label.vue?vue&type=style&index=0&id=cf94f02a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf94f02a",
  null
  
)

export default component.exports